import { NetworkError, deepCamelCase, searchQueryString } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetMeFollowingFields = readonly string[];

/** Options for GET /me/following/{follow_user_id} */
export type GetMeFollowingOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the user to follow.
     */
    followUserId: number;
  };
};

/** Result type for GET /me/following/{follow_user_id} */
export type GetMeFollowingResult<Paths extends readonly string[]> = unknown;

/**
 * Check if the user is following another user
 * This method determines whether the authenticated user is a follower of the specified user.
 */
export async function getMeFollowing<Paths extends GetMeFollowingFields>({
  baseUrl,
  where: { followUserId },
  ...options
}: GetMeFollowingOptions<Paths>): Promise<GetMeFollowingResult<Paths>> {
  let res = await fetch(`${baseUrl}/me/following/${followUserId}`, {
    ...options,
    method: 'GET',
  });

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as GetMeFollowingResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}

export type PutMeFollowingFields = readonly string[];

/** Options for PUT /me/following/{follow_user_id} */
export type PutMeFollowingOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the user to follow.
     */
    followUserId: number;
  };

  /** Possible query parameters for /me/following/{follow_user_id} */
  query?: {
    /**
     * Whether to enforce an email verification check before making the authenticated
     * user a follower of the specified user. If the authenticated user's account has no uploaded videos and is created after September 1, 2016, an email
     * verification check is required before the authenticated user can follow the specified user.
     */
    checkEmailVerification?: boolean;

    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };
};

/** Result type for PUT /me/following/{follow_user_id} */
export type PutMeFollowingResult<Paths extends readonly string[]> = unknown;

/**
 * Follow a specific user
 * This method causes the authenticated user to become the follower of the specified user.
 */
export async function putMeFollowing<Paths extends PutMeFollowingFields>({
  baseUrl,
  where: { followUserId },
  query,
  ...options
}: PutMeFollowingOptions<Paths>): Promise<PutMeFollowingResult<Paths>> {
  let res = await fetch(`${baseUrl}/me/following/${followUserId}?${searchQueryString(query)}`, {
    ...options,
    method: 'PUT',
  });

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as PutMeFollowingResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}

export type DeleteMeFollowingFields = readonly string[];

/** Options for DELETE /me/following/{follow_user_id} */
export type DeleteMeFollowingOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the user to unfollow.
     */
    followUserId: number;
  };

  /** Possible query parameters for /me/following/{follow_user_id} */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };
};

/** Result type for DELETE /me/following/{follow_user_id} */
export type DeleteMeFollowingResult<Paths extends readonly string[]> = unknown;

/**
 * Unfollow a user
 * This method causes the authenticated user to stop following another user.
 */
export async function deleteMeFollowing<Paths extends DeleteMeFollowingFields>({
  baseUrl,
  where: { followUserId },
  query,
  ...options
}: DeleteMeFollowingOptions<Paths>): Promise<DeleteMeFollowingResult<Paths>> {
  let res = await fetch(`${baseUrl}/me/following/${followUserId}?${searchQueryString(query)}`, {
    ...options,
    method: 'DELETE',
  });

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as DeleteMeFollowingResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
